import RcBtn from "@/libvuePure/bootstrap/Button.vue";

// Cross version component registration
// vuejs2: Vue.component("foo", bar)
// vuejs3: app.component("foo", bar)
export const registerComponent = (app) => {
  app.component("RcBtn", RcBtn);
};
